import React, { useState, useEffect, useRef, useMemo } from "react";
// ANT DESIGN COMPONENTS
import { Tooltip, Descriptions } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import { useLastBankMessage } from "../socketMessageState/BankMessagesContext";
// INTERFACES
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
// CONSTANTS
import { BLANK_SOCKET_MESSAGE } from "../../../constants/monitoring";
// UTILS
import { stringToUuidT } from "../../../utils/uuid";

function MonitoringHeartBeat({
  bankId,
  type,
}: {
  bankId: string;
  type: "TOOLTIP" | "DESCRIPTION";
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const disconnectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  // Start optimistically connected — loading state ≠ disconnected state.
  // The 10s timer will flip to false only if no message with connected=true arrives.
  const [connected, setConnected] = useState<boolean>(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const bankUuid = useMemo(() => stringToUuidT(bankId), [bankId]);
  const socketMessageBank: SocketMessageInterface =
    useLastBankMessage(bankUuid) || BLANK_SOCKET_MESSAGE;

  // ************************************************ */
  // HELPERS **************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // USE MEMO *************************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE CALLBACK *********************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // EFFECT ***************************************** */
  useEffect(() => {
    if (socketMessageBank.connected) {
      if (disconnectTimeoutRef.current) {
        clearTimeout(disconnectTimeoutRef.current);
        disconnectTimeoutRef.current = null;
      }
      setConnected(true);
      return;
    }

    if (!disconnectTimeoutRef.current) {
      disconnectTimeoutRef.current = setTimeout(() => {
        setConnected(false);
        disconnectTimeoutRef.current = null;
      }, 10000);
    }
  }, [socketMessageBank.connected]);

  // ************************************************ */
  // COMPONENT ************************************** */
  const statusText = connected ? t("general.good") : t("general.noNetwork");
  const statusClassName = connected ? "generalStyles__success" : "generalStyles__error";
  const statusIndicator = (
    <Tooltip title={statusText}>
      <FontAwesomeIcon icon={faCircle} className={statusClassName} />
    </Tooltip>
  );

  return (
    <>
      {type === "TOOLTIP" ? (
        <div className="generalStyles__mrFix">{statusIndicator}</div>
      ) : (
        <Descriptions bordered size="small" column={2}>
          <Descriptions.Item
            label={<div className="generalStyles__flexCenter">{statusIndicator}</div>}
          >
            <div className="generalStyles__flexCenter">{statusText}</div>
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
}

export default React.memo(MonitoringHeartBeat);
